<template>
    <div class="box">
        <h2>
            Inhaltlische Einstellungen für den MietkautionsDepot Prozess
        </h2>
        <div class="body">
            <h3 style="margin:0; padding:0;">Fußnote im Tarif</h3>
            <div class="form-group form-float no-error" style="margin-bottom: 32px;">
                <textarea v-model="fussnote_tarif" name="vision_prompt" v-validate="'required'" id="fussnote_tarif"></textarea>
                <label for="fussnote_tarif">Fußnote</label>
                <span class="error" v-show="errors.has('fussnote_tarif')">{{ errors.first("fussnote_tarif") }}</span>
            </div>
            <hr />
            <div class="button-row">
                <button @click="save()" type="button" class="primary size-l"><i class="fal fa-save"></i> Speichern</button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            fussnote_tarif: ""
        };
    },
    created() {
        this.fetchData();
    },
    methods: {
        save() {
            var settings = {
                fussnote_tarif: ""
            };

            settings.fussnote_tarif = this.fussnote_tarif;

            this.$api.put("/mietkautionsdepot/inhalte", settings).then(
                () => {
                    this.$snotify.success("Einstellungen gespeichert");
                },
                () => {
                    this.$snotify.error("Speichern fehlgeschlagen");
                }
            );
        },
        fetchData() {
            this.$api.get("/mietkautionsdepot/inhalte").then(
                response => {
                    if (response.data.data === null) {
                        response.data.data = {
                            fussnote_tarif: ""
                        };
                    }

                    this.fussnote_tarif = response.data.data.fussnote_tarif;
                },
                () => {
                    this.$snotify.error("Fehler beim Laden der Einstellungen");
                }
            );
        }
    }
};
</script>
